

























import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import SharedMixin from '@/mixins/SharedMixin';

import { ExpertiseTableModel } from '@/services/iResourceService';

@Component({})
export default class PgaExpertisesTableIndex extends mixins(SharedMixin)
{
    @Prop({ default: function() { return new Array<ExpertiseTableModel>() } }) readonly ExpertisesList!: Array<ExpertiseTableModel>;
    @Prop({ default: true }) readonly isLoading!: boolean;

    headers: Array<any> =
    [
		{
			text: 'Code',
			align: 'start',
			sortable: true,
            value: 'Code',
            width: "6%",
            keySearch: "co",
        },
        {
			text: 'Description',
			align: 'start',
			sortable: true,
			value: 'Description',
            keySearch: "de",
        },
        {
			text: 'Tech Areas',
			align: 'start',
			sortable: false,
			value: 'TechAreas',
            keySearch: "ta",
        },
        {
			text: 'Technologies',
			align: 'start',
			sortable: false,
			value: 'Technologies',
            keySearch: "tch",
        },
    ];

    rowClicked (item: any) : void
    {
		const id = item.Id;
		this.$router.push({ name: 'expertisedetails', params: { id }});
	}
}
